import React from 'react';
import { StarsIcon } from '@newcore/icons';
import { Onboarding } from '@/features/onboarding/components/primitives';
import type { FactorType } from '@/features/onboarding/types/onboarding.types';
import { EnrolledFactorsList } from '../complete-step/enrolled-factors-list';

interface TenantCompleteStepSuccessProps {
  userName?: string;
  enrolledFactors: FactorType[];
  onComplete: () => void | Promise<void>;
}

/**
 * Tenant Complete Step Success UI
 * Shows success message, enrolled factors, and button to continue to admin console
 */
export const TenantCompleteStepSuccess: React.FC<
  TenantCompleteStepSuccessProps
> = ({ userName, enrolledFactors, onComplete }) => {
  const displayName = userName?.split(' ')[0] ?? 'there';

  return (
    <div className='flex flex-col items-center text-center space-y-6 py-4'>
      <Onboarding.Icon className='h-20 w-20 bg-utility-green-100 text-utility-green-700 [&>svg]:h-10 [&>svg]:w-10'>
        <StarsIcon />
      </Onboarding.Icon>

      <Onboarding.Header>
        <Onboarding.Title>Setup Complete, {displayName}!</Onboarding.Title>
        <Onboarding.Description>
          Your tenant is now active. Access the Admin Console below.
        </Onboarding.Description>
      </Onboarding.Header>

      <EnrolledFactorsList factors={enrolledFactors} />

      <Onboarding.NextButton onClick={onComplete} className='w-full max-w-sm'>
        Go to Admin Console
      </Onboarding.NextButton>
    </div>
  );
};
